import moment from "moment";

export default {

    getEarliestEventStart(order) {
        let start = null;
        if(order && order.lineItems) {
            order.lineItems.forEach((item) => {
                if(item.event && item.event.start && (start === null || moment(item.event.start).isBefore(start))) {
                    start = item.event.start;
                }
            });
        }
        return start;
    },


}